import './assets/main.css'
import './common/style/common.css'

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import registerPlugin from './plugin'
import IntlCurrency from './components/IntlCurrency/index.vue'
import SvgIcon from './components/SvgIcon/index.vue'
import NumberInput from './components/NumberInput/index.vue'
import { VueFuncallPlugin } from 'vue-funcall'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { createSyncPlugin } from '@/pinia/plugins/create-sync-plugin'

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
pinia.use(createSyncPlugin())

const app = createApp(App)

app.component('IntlCurrency', IntlCurrency)
app.component('SvgIcon', SvgIcon)
app.component('NumberInput', NumberInput)

registerPlugin(app)

app.use(router)
app.use(store)
app.use(pinia)
app.use(VueFuncallPlugin)
app.mount('#app')
